import { render, staticRenderFns } from "./CardStagesBlock.vue?vue&type=template&id=31baea47&scoped=true"
import script from "./CardStagesBlock.vue?vue&type=script&lang=js"
export * from "./CardStagesBlock.vue?vue&type=script&lang=js"
import style0 from "./CardStagesBlock.vue?vue&type=style&index=0&id=31baea47&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31baea47",
  null
  
)

export default component.exports